import { css } from 'styled-components';

/*
 * 共通利用できるCSSを格納
 * styled-components内で識別する為、mixinのプリフィックスをつける
 */

// iconを囲う丸枠
export const mixinCircle = css`
  background: #fafbfc 0% 0% no-repeat;
  box-shadow: 1px 1px 2px #0000000b;
  border: 1px solid #a2b2be;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
